import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./theme/tokens.css";
import { applyTheme, readThemeHint } from "./theme/theme";

// 開頁先照上次記下的提示套用主題,/auth/me 回來再以帳號上的為準 ——
// 少了這一步,選了暗色的人每次開頁都會先閃一下亮色。
applyTheme(readThemeHint());

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // 報價單是自己編自己的,不需要一切回焦點就重抓。
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 30_000,
    },
  },
});

const container = document.getElementById("root");
if (!container) throw new Error("找不到 #root 掛載點");

ReactDOM.createRoot(container).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      {/* 前端掛在 /quote/ 底下,basename 必須與 Vite base 一致。 */}
      <BrowserRouter basename="/quote">
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
);
